// import React, { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
// import { ChevronUp } from "lucide-react";

// const ScrollTopManager = () => {
//   const location = useLocation();
//   const [showButton, setShowButton] = useState(false);

//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }, [location.pathname]);

//   useEffect(() => {
//     const onScroll = () => {
//       setShowButton(window.scrollY > 250);
//     };

//     window.addEventListener("scroll", onScroll, { passive: true });
//     onScroll();

//     return () => window.removeEventListener("scroll", onScroll);
//   }, []);

//   const handleScrollTop = () => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   return (
//     <button
//       type="button"
//       onClick={handleScrollTop}
//       aria-label="Scroll to top"
//       className={`md:hidden fixed bottom-5 right-4 z-[70] rounded-full p-3 shadow-lg transition-all duration-200 ${
//         showButton
//           ? "opacity-100 translate-y-0 pointer-events-auto bg-primary text-primary-foreground"
//           : "opacity-0 translate-y-3 pointer-events-none bg-primary text-primary-foreground"
//       }`}
//     >
//       <ChevronUp size={20} />
//     </button>
//   );
// };

// export default ScrollTopManager;



import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ChevronUp } from "lucide-react";

const ScrollTopManager = () => {
  const location = useLocation();
  const [showButton, setShowButton] = useState(false);

  // Scroll to top on route change - THIS IS THE FIX
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant" // Use "instant" instead of "smooth" for immediate scroll
    });
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => {
      setShowButton(window.scrollY > 250);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleScrollTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  };

  return (
    <button
      type="button"
      onClick={handleScrollTop}
      aria-label="Scroll to top"
      className={`md:hidden fixed bottom-5 right-4 z-[70] rounded-full p-3 shadow-lg transition-all duration-200 ${
        showButton
          ? "opacity-100 translate-y-0 pointer-events-auto bg-primary text-primary-foreground"
          : "opacity-0 translate-y-3 pointer-events-none bg-primary text-primary-foreground"
      }`}
    >
      <ChevronUp size={20} />
    </button>
  );
};

export default ScrollTopManager;